import { Action } from 'redux';

export enum CommonActionTypes {
    ClearStore = "CLEAR_STORE"
}

export interface ClearStore extends Action{
    type: CommonActionTypes.ClearStore;
}